import React, { ChangeEvent } from "react";
import { SelectChangeEvent, TextField, Autocomplete, FormControlLabel, Checkbox, MenuItem, Select, Button, CardMedia, IconButton, Input } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const usersList = [
  { label: 'Select All Users', id: 'all' },
  { label: 'John Doe, john@yopmail.com', id: '1' },
  { label: 'Jane Smith, jane@yopmail.com', id: '2' },
  { label: 'Michael Scott, michael@yopmail.com', id: '3' },
  { label: 'Pam Beesly, pam@yopmail.com', id: '4' },
];

const AddNotification = () => {

  const navigate = useNavigate();

  const [alertMessage, setAlertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertType, setAlertType] = React.useState(0);
  const [image, setImage] = React.useState<string>("");
  const [fileName, setFileName] = React.useState<string>("");

  const [autoCompleteOpen, setAutoCompleteOpen] = React.useState(true);
  const [selectedUsers, setSelectedUsers] = React.useState<typeof usersList>([]);
  const [type, setType] = React.useState('default');
  const [schedule, setSchedule] = React.useState('default');
  const [link, setLink] = React.useState('default');
  const [rewards, setRewards] = React.useState('default');

  const handleUsersChange = (event: any, value: typeof usersList) => {
    const isSelectAllClicked = value.some((user) => user.id === 'all');

    if (isSelectAllClicked) {
      const isAllSelected = selectedUsers.length === usersList.length - 1;

      if (isAllSelected) {
        // Uncheck all
        setSelectedUsers([]);
      } else {
        // Select all (excluding "Select All" option itself)
        const allUsers = usersList.filter((user) => user.id !== 'all');
        setSelectedUsers(allUsers);
      }
    } else {
      setSelectedUsers(value);
    }
  };

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };
  const handleScheduleChange = (event: SelectChangeEvent) => {
    setSchedule(event.target.value as string);
  };
  const handleLinkChange = (event: SelectChangeEvent) => {
    setLink(event.target.value as string);
  };
  const handleRewardsChange = (event: SelectChangeEvent) => {
    setRewards(event.target.value as string);
  };

  return (
    <>
      <div className="main_title">
        <h1>Add Notification</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - {" "}
          <button onClick={() => navigate("/manage-notifications")}>Notification & Communication Center</button> -
          Add Notification
        </p>
      </div>

      <div className="cards">
        <form className="form" action="">
          <div className="gap_p">
            <div className="control_group w_100">
              <label htmlFor="icon-button-file">Upload Image (optional)</label>
              {image ? (
                <div className="upload_image no_radius">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="Uploaded profile photo" />
                    </figure>
                    <IconButton
                      aria-label="Remove uploaded image"
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                      size="small"
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                </div>
              ) : (
                <label className="upload_image no_radius" htmlFor="icon-button-file">
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{ accept: "image/png,image/jpeg" }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = (event.target as HTMLInputElement).files;
                      if (files && files[0].type.includes("image")) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      } else {
                        setAlertType(0);
                        setShowAlert(true);
                        setAlertMessage("This field only accepts images.");
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img src="/static/images/placeholder.png" alt="placeholder" />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="Upload" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>
            <div className="control_group w_50">
              <label htmlFor="noti_title">Notification Title</label>
              <TextField
                id="noti_title"
                placeholder="Enter Notification Title"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label htmlFor="noti_type">Type</label>
              <Select
                id="noti_type"
                fullWidth
                value={type}
                onChange={handleTypeChange}
              >
                <MenuItem disabled value="default">Select Type</MenuItem>
                <MenuItem value="broadcast">Broadcast</MenuItem>
                <MenuItem value="email">Email</MenuItem>
                <MenuItem value="push">Push Notification</MenuItem>
              </Select>
            </div>
            <div className="control_group w_100">
              <label htmlFor="noti_audience">Audience</label>
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={usersList}
                value={selectedUsers}
                onChange={handleUsersChange}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onOpen={() => setAutoCompleteOpen(true)}
                onClose={() => setAutoCompleteOpen(false)}
                renderOption={(props, option, { selected }) => {
                  const isAllOption = option.id === 'all';
                  const isAllSelected = selectedUsers.length === usersList.length - 1; // exclude "Select All"
                  return (
                    <li {...props}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isAllOption ? isAllSelected : selected}
                            indeterminate={isAllOption && selectedUsers.length > 0 && !isAllSelected}
                          />
                        }
                        name="option"
                        label={option.label}
                      />
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} id="noti_audience" placeholder="Select Audience" />
                )}
              />
            </div>
         
            {schedule === "2" && (
              <div className="control_group w_50">
                <label htmlFor="noti_datetime"> Date & Time</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    className="form_control"
                    slots={{
                      openPickerIcon: () => <img src="/static/images/date_icon.svg" alt="Pick date" />,
                    }}
                    slotProps={{
                      textField: {
                        id: "noti_datetime",
                        placeholder: "Select Date & Time",
                        fullWidth: true,
                        hiddenLabel: true,
                      },
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>
            )}
            <div className="control_group w_100">
              <label htmlFor="noti_message">Notification Message</label>
              <TextField
                id="noti_message"
                placeholder="Enter Notification Message"
                fullWidth
                hiddenLabel
                multiline
                maxRows={5}
                minRows={5}
              />
            </div>
           
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary" onClick={() => navigate('/manage-notifications')}>Submit</Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddNotification;
